import { Box } from '@mui/material';
import { observer } from 'mobx-react';
import React from 'react';
import { IProjectLearningReportArg } from '../../../service/report/interface/IProjectLearningReportArg';

import { StudyReportNavbar } from './StudyReportNavbar';
import { RatingsSection } from './RatingsSection';
import { MetricsSection } from '../shared/MetricsSection';
import { MetricsDomain } from '../shared/MetricsSection/store/MetricsDomain';
import { MetricsHistorySection } from '../shared/MetricsHistorySection';

type IStudyDashboardWrapperProperties = {
  reportArg?: IProjectLearningReportArg;
  showReportNavbar?: boolean;
};

export const StudyDashboardWrapper = observer(
  ({ reportArg = {}, showReportNavbar = true }: IStudyDashboardWrapperProperties) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: '24px',
        height: '100%',
        minHeight: 0,
        overflow: 'auto',
      }}
    >
      {showReportNavbar ? (
        <Box sx={{ flexShrink: 0 }}>
          <StudyReportNavbar reportArg={reportArg} />
        </Box>
      ) : null}
      <Box sx={{ flexShrink: 0 }}>
        <MetricsSection metricsDomain={new MetricsDomain()} reportArg={reportArg} />
      </Box>
      {/* <Box sx={{ flexShrink: 0 }}>
        <MetricsHistorySection reportArg={reportArg} />
      </Box> */}
      <Box>
        <RatingsSection reportArg={reportArg} />
      </Box>
    </Box>
  );
  },
);
